const redux = require('redux')
let store
let activeButton = ''
let activeSubButton = ''
let activeSelects = new Map()
const initState = {
	filters: {},
	activeButton: activeButton,
	activeSubButton: activeSubButton,
	activeSelects: activeSelects,
	mapInitialized : false,
	locationsLoaded: false,
	locations: new Set(),
	visibleLocations: new Set(),
	config: {}
}

function init(config) {
	store = redux.createStore(reducer)
	store.subscribe(() => {
		filterChanged(store)
	})
	store.dispatch({type: 'init', config: config})
	return getStore();
}

function getStore() {
	if(!store) {
		throw new Error('store was not initialized')
	}
	return store;
}

/**
 * update state
 *
 * @param {{filter: Set<String|int>}} state
 * @param {{type: string, activeFilter: <String|int>}} action
 */
function reducer (state = initState, action) {
	switch(action.type) {
		case 'init':
			state.config = action.config
			break;
		case 'subButton':
			if(state.activeSubButton == action.filter) {
				state.activeSubButton = ''
			} else {
				state.activeSubButton = action.filter
			}
			for (let key of state.activeSelects.keys()) {
				let filterHierarchy = state.config.filterHierarchy[state.activeSubButton]
				if(!filterHierarchy || !filterHierarchy.includes(key)) {
					state.activeSelects.delete(key)
				}
			}
			if(state.config.filterHierarchy[state.activeSubButton]) {
				for (let filter of state.config.filterHierarchy[state.activeSubButton]) {
					if (!state.activeSelects.has(filter) && state.config.filterDefaults[filter]) {
						state.activeSelects.set(filter, state.config.filterDefaults[filter])
					}
				}
			}
			state.activeSelects = new Map(state.activeSelects.entries())
			break;
		case 'button':
			if(state.activeButton == action.filter) {
				state.activeButton = ''
				state.activeSubButton = ''
			} else {
				state.activeButton = action.filter
				state.activeSubButton = ''
			}
			for (let key of state.activeSelects.keys()) {
				let filterHierarchy = state.config.filterHierarchy[state.activeSubButton]
				if(!filterHierarchy || !filterHierarchy.includes(key)) {
					state.activeSelects.delete(key)
				}
			}
			state.activeSelects = new Map(state.activeSelects.entries())
			break;
		case 'select':
			if(action.value) {
				state.activeSelects.set(action.filter, action.value)
			} else {
				state.activeSelects.delete(action.filter)
			}
			state.activeSelects = new Map(state.activeSelects.entries())
			break;
		case 'locationsFiltered':
			state.visibleLocations = new Set(action.filteredLocations)
			break;
		case 'locationsLoaded':
			state.locations = new Set(action.locations)
			state.visibleLocations = state.locations
			state.locationsLoaded = true
			state.filters = action.filters
			break;
		case 'mapInitialized':
			state.mapInitialized = true
			break;
	}

	return state
}

function filterChanged(store) {
	const state = store.getState()
	const config = state.config
	if(state.activeButton === activeButton && state.activeSelects === activeSelects) {
		return
	}

	activeButton = state.activeButton
	activeSubButton = state.activeSubButton
	activeSelects = state.activeSelects
	locations = state.locations
	let filteredLocations

	if(activeButton) {
		let filterKeys = config.filterKeys[activeButton]
		filteredLocations = [...locations].filter(
			location => filterKeys.some(
				filterKey => location[filterKey] && location[filterKey].length
			)
		)
	} else {
		filteredLocations = [...locations]
	}

	if(activeSelects.size) {
		for (let[key, value] of activeSelects) {
			let filterKeys = config.filterKeys[key];
			filteredLocations = filteredLocations.filter(
				location => filterKeys.some(
					filterKey => location[filterKey] && location[filterKey].some(item => value.test ? value.test(item) : item == value)
				)
			)
		}
	}

	store.dispatch({type: 'locationsFiltered', filteredLocations: filteredLocations})
}

module.exports = {
	init
}
